import { removeWorkflowPusherConnection, selectWorkflowId } from '@/store/modules/selectedWorkflow/actions';
import { useStore } from '@/utils/store';
import { WorkflowId } from '@ply-io/ply-front-shared-utilities';

export const useSelectedWorkflowActions = () => {
	const { dispatch } = useStore();
	return {
		removeWorkflowPusherConnection: () => dispatch<undefined, void>(removeWorkflowPusherConnection, undefined),
		selectWorkflowId: (workflowId: WorkflowId) => dispatch<{ id: WorkflowId }, void>(selectWorkflowId, { id: workflowId }),
	};
};
